var list = document.querySelectorAll('.compile-comp-chart');
for (var item of list) {
    item.checked = false;
}
if (!customElements.get('comp-chart-modal')) {
  customElements.define(
    'comp-chart-modal',
    class CompChartModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="CompChartInfo-"]');
        this.modalHeadings = this.querySelector('[id^="CompChartHeadings-"]');
        this.modalData = this.querySelector('[id^="CompChartData-"]');
        this.modalTopper = this.querySelector('[id^="CompChartTopper-"]');
        this.compileButtons();
        this.addEventListener('comparison-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        //this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      
      preprocessHTML(productElement) {
          productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient')
              this.modalContent.classList.add(classApplied);
          });
          this.preventDuplicatedIDs(productElement);
      }
  
      preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;
  
          const oldId = sectionId;
          const newId = `compchart-${sectionId}`;
          productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
          Array.from(productElement.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
            }
          });
  
          productElement.dataset.originalSection = sectionId;
      }

      // Hide any comparison row where no selected product has a value.
      // Rows align by data-mh ("table-<category>-<index>") between headings and data cells.
      hideEmptyRows() {
        if (!this.modalHeadings || !this.modalData) return;
        this.modalHeadings.querySelectorAll('.comp-heading[data-mh]').forEach((heading) => {
          const key = heading.getAttribute('data-mh');
          const cells = this.modalData.querySelectorAll('.data-point[data-mh="' + key + '"]');
          let hasContent = false;
          cells.forEach((cell) => {
            if (cell.querySelector('svg') || cell.textContent.replace(/ /g, '').trim() !== '') hasContent = true;
          });
          const display = hasContent ? '' : 'none';
          heading.style.display = display;
          cells.forEach((cell) => { cell.style.display = display; });
        });
      }

      compileButtons() {
          document.querySelectorAll('.compile-comp-chart').forEach((compiler) => {
            let _this = this;
              compiler.addEventListener('change', function (event) {
                if (compiler.checked) {
                  
                //check number of available slots
                var images = document.querySelectorAll('.comp-chart-bar-images .image:empty');
                  if(images.length){                         
                      fetch(event.target.getAttribute('data-product-url'))
                      .then((response) => response.text())
                      .then((responseText) => {
                          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                          const productID = event.target.getAttribute('data-product-id');
                            const labelFor = event.target.getAttribute('id');
                          const headingsElement = responseHTML.querySelector('comparison-info chart-headings');
                          const dataElement = responseHTML.querySelector('comparison-info chart-data');
                          const featuredImageURL = event.target.getAttribute('data-image');
                          const productTitle = event.target.getAttribute('data-title');
                          const productPrice = event.target.getAttribute('data-price');
                          const featuredImage = '<img src="'+featuredImageURL+'" width="200" height="200" id="comp-thumb--'+productID+'" />';
                          const featuredLargeImageURL = event.target.getAttribute('data-image-large');
                          const featuredLargeImage = '<div class="center"><img src="'+featuredLargeImageURL+'" width="240" height="240" id="comp-large--'+productID+'" /><h4 class="center semibold">'+productTitle+'</h4><div class="center grey">'+productPrice+'</div></div>';
                          let firstEmptyImage = document.querySelector('.comp-chart-bar-images .image:empty');

                          _this.preprocessHTML(headingsElement);
                          _this.preprocessHTML(dataElement);
                          HTMLUpdateUtility.setInnerHTML(_this.modalHeadings, headingsElement.outerHTML);
                          HTMLUpdateUtility.setInnerHTML(firstEmptyImage, featuredImage);
                          _this.modalTopper.innerHTML += featuredLargeImage;
                          _this.modalData.innerHTML += dataElement.outerHTML;
                            document.querySelector('label[for="'+labelFor+'"]').innerHTML = 'Remove';
                          _this.hideEmptyRows();
                          //match height
                          const containers = document.querySelectorAll(".comp-chart-inner-wrapper");
                          containers.forEach((container) => {
                              container.matchHeight({attributeName: 'data-mh'});
                          });  
                          window.dispatchEvent(new Event('resize'));
                          _this.checkCompilersAvailability();
                      })
                  } else {
                      console.log('no image slots available');
                      _this.disableAllCompilers();
                  }
              } else {
                fetch(event.target.getAttribute('data-product-url'))
                      .then((response) => response.text())
                      .then((responseText) => {
                          const productID = event.target.getAttribute('data-product-id');
                          
                          //remove thumb image
                          const thumbImage = document.getElementById('comp-thumb--'+productID);
                          thumbImage.remove();
                          //remove large image
                          const largeImage = document.getElementById('comp-large--'+productID);
                          largeImage.remove();
                          //remove data
                            //const compDataColumn = document.getElementById('comp-data--'+productID);
                            const compDataParent = document.getElementById('comp-data--'+productID).parentNode;
                            compDataParent.remove();
                            // change button text
                            const labelFor = event.target.getAttribute('id');
                            document.querySelector('label[for="'+labelFor+'"]').innerHTML = 'Compare';
                          
                          _this.hideEmptyRows();
                          //match height
                          const containers = document.querySelectorAll(".comp-chart-inner-wrapper");
                          containers.forEach((container) => {
                              container.matchHeight({attributeName: 'data-mh'});
                          });  
                          window.dispatchEvent(new Event('resize'));
                          _this.checkCompilersAvailability();
                //console.log('remove -unchecked')
              
              });
          
                      }
                                });
      });
    }
      checkCompilersAvailability(){
          var images = document.querySelectorAll('.comp-chart-bar-images .image:empty');
          var comp_button = document.querySelector('.comp-chart-bar-button button');
          var comp_bar = document.querySelector('.comp-chart-bar');
          if(images.length){
            console.log(images.length)
            if(images.length > 2){
              comp_bar.classList.add('small-hide')
            } else {
              if(images.length >= 2){
              comp_bar.classList.remove('small-hide')
              comp_button.disabled = true;
              } else {
              comp_button.disabled = false;
              comp_bar.classList.remove('small-hide')
              }
            }
          } else {
            comp_button.disabled = false;
            comp_bar.classList.remove('small-hide')
            this.disableAllCompilers();
          }
      }
      disableAllCompilers(){
          document.querySelectorAll('.compile-comp-chart:not(:checked)').forEach((compiler) => {
              if (compiler.checked){
                //do nothing
              } else {
                compiler.setAttribute('disabled', 'disabled');
                compiler.setAttribute('aria-disabled', true);
              }
          });   
      }
    }
  );
  
    
}
